<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">登录名称:</span>
        <el-input
          placeholder="请输入关键词"
          v-model="rolelistPage.username"
          clearable
        >
        </el-input>
		<span class="fonints">中文名称:</span>
		<el-input
		  placeholder="请输入关键词"
		  v-model="rolelistPage.chineseName"
		  clearable
		>
		</el-input>
        <el-radio-group v-model="rolelistPage.systemName">
          <el-radio style="margin-left: 10px" label="system">系统管理</el-radio>
          <el-radio label="fleet">代理账户</el-radio>
          <el-radio label="driver">司机账户</el-radio>
          <el-radio label="custom">货主/货代</el-radio>
          <el-radio label="flow">流向</el-radio>
        </el-radio-group>
        <button class="buttons" @click="selectlist">查询</button>
        <button class="buttons" @click="addusersinfo">添加用户</button>
      </div>
      <div class="componentSty_content_table">
        <el-table :data="rolelist.list" style="width: 100%; height: 80%"  height="80%">
           <el-table-column
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column prop="chineseName" label="用户名"> </el-table-column>
          <el-table-column prop="username" label="登录名"> </el-table-column>
          <el-table-column prop="mobile" label="联系方式"> </el-table-column>
          <el-table-column label="创建日期">
            <template v-slot="res">
              {{ mydateFormat(res.row.createTime, "时分秒") }}
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template v-slot="res">
              <span
                v-if="res.row.status === 1"
                class="el_spanfontstyle"
                style="color: #17B6A1"
                >启用</span
              >
              <span
                v-if="res.row.status === 0"
                class="el_spanfontstyle"
                style="color: #fe5a24"
                >禁用</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="res">
              <span
                class="iconfont icon-xiugai"
                @click="itemparticulars(res.row)"
              ></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations" v-show="rolelist.list&&rolelist.list.length">
          <el-pagination
            :page-size="rolelistPage.limit"
            :pager-count="5"
            :current-page="rolelistPage.page"
            layout="total,prev, pager,next, jumper"
            :total="rolelist.totalCount"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </div>
      <m-dialog :isShow="addrole" @changeState="sendMsg" :title="title">
        <div class="inForMsgBox">
          <div class="itemBox" style="width: 100%; line-height: 30px">
            <span class="key" style="width: 21%">用户名称</span>
            <div class="val" style="background: #f3f4f5">
              <m-superIpt
                defaultInfo="请输入用户名称"
                v-model.lazy="infoobj.chineseName"
              ></m-superIpt>
            </div>
          </div>
          <div class="itemBox" style="width: 100%; line-height: 30px">
            <span class="key" style="width: 21%">登录名</span>
            <div class="val" style="background: #f3f4f5">
              <m-superIpt
                defaultInfo="请输入登录名"
                v-model.lazy="infoobj.username"
              ></m-superIpt>
            </div>
          </div>
          <div class="itemBox" style="width: 100%; line-height: 30px">
            <span class="key" style="width: 21%">联系方式</span>
            <div class="val" style="background: #f3f4f5">
              <m-superIpt
                defaultInfo="请输入联系方式"
                rule="tel"
                v-model.lazy="infoobj.mobile"
              ></m-superIpt>
            </div>
          </div>
          <div class="itemBox" style="width: 100%; line-height: 30px">
            <span class="key" style="width: 21%">密码</span>
            <div class="val" style="background: #f3f4f5">
              <m-superIpt
                defaultInfo="请填写密码"
                type="password"
                v-model.lazy="infoobj.password"
              ></m-superIpt>
            </div>
          </div>
          <div class="itemBox" style="width: 100%; line-height: 30px">
            <span class="key" style="width: 21%">确认密码</span>
            <div class="val" style="background: #f3f4f5">
              <m-superIpt
                :defaultInfo="infomsg"
                type="password"
                v-model.lazy="password1"
              ></m-superIpt>
            </div>
          </div>
          <div
            class="itemBox"
            style="width: 100%; height: 30px; overflow: auto"
          >
            <span
              v-for="item in checkitem"
              style="float: left; margin: 0 10px"
              :key="item.roleId"
            >
              <el-tooltip
                effect="dark"
                :content="item.roleName"
                placement="top"
                :enterable="false"
              >
                <m-chebox v-model="item.check">
                  {{ item.roleName }}
                </m-chebox>
              </el-tooltip>
            </span>
          </div>
        </div>
      </m-dialog>
    </div>
  </div>
</template>

<script>
import mTitle from "@/components/mTitle";
import mDialog from "@/components/mDialog";
import mChebox from "@/components/mChebox.vue";
import mSuperIpt from "@/components/mSuperIpt";
import { mapMutations, mapState } from "vuex";
import { encrypt} from '@/utils/jsencrypt'
export default {
  inject: ["reload"],
  data() {
    return {
      listitem: [{ name: "角色管理" }, { name: "用户列表" }],
      timeout: null,
      rolelist: {},
      addrole: false,
      title: "添加用户",
      path: "/sys/user/save",
      checkitem: [],
      password1: "", //确认密码
      infomsg: "请确认密码",
      infoobj: {
        sys: "",
        chineseName: "", //用户名
        username: "", //登录名称
        mobile: "", //联系方式
        password: "", //密码
        roleIdList: [],
        systemName: "system", //用户名
      },
      rolelistPage: {},
    };
  },
  components: {
    mTitle,
    mDialog,
    mSuperIpt,
    mChebox,
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  created() {
    this.conditionsList[this.$route.path] ||
      this.createConditions({
        key: this.$route.path,
        val: {
          page: 1,
          limit: 20,
          systemName: "system",
        },
      });
    this.rolelistPage = this.conditionsList[this.$route.path] || {
      page: 1,
      limit: 20,
      systemName: "system",
    };
    this.getalluselist();
  },
  methods: {
    ...mapMutations(["createConditions"]),
    async getalluselist() {
      const { data } = await this.$http(
        "api1",
        "/sys/user/list",
        "get",
        this.rolelistPage
      );
      if (!data || data.msg != "success") return;
      this.rolelist = data.page;
      const { data: data1 } = await this.$http("api1", "/sys/role/list", "get");
      if (!data1 || data1.msg != "success")
        return this.$message.error("获取数据失败");
      this.checkitem = data1.page.list.filter((item) => {
        item.check = 0;
        return true;
      });
    },
    // 修改用户
    async itemparticulars(item) {
      this.addrole = true;
      this.infoobj.userId = item.userId;
      this.infoobj.chineseName = item.chineseName;
      this.infoobj.username = item.username;
      this.infoobj.mobile = item.mobile;
      this.infoobj.systemName = item.systemName;
      this.path = "/sys/user/update";
      this.title = "修改用户";
      const {
        data: {
          user: { roleIdListString },
        },
      } = await this.$http("api1", "/sys/user/info/" + item.userId, "get");
      if (!roleIdListString || !roleIdListString.length) return "";
      this.checkitem.forEach((item) => {
        roleIdListString.includes(item.roleId)
          ? (item.check = 1)
          : (item.check = 0);
      });
    },
    // 查询用户
    selectlist() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.rolelistPage.page = 1;
        this.getalluselist();
      }, 300);
    },
    // 添加用户
    addusersinfo() {
      this.addrole = true;
      delete this.infoobj.userId;
      this.path = "/sys/user/save";
    },
    currentChange(item) {
      if (this.rolelist.totalCount <= this.rolelistPage.limit) return;
      this.rolelistPage.page = item;
      this.getalluselist();
    },
    async sendMsg(item) {
      if (item != "confirm") {
        this.password1 = "";
        this.checkitem.forEach((item) => {
          item.check = 0;
        });
        for (let i in this.infoobj) {
          this.infoobj[i] = Array.isArray(this.infoobj[i]) ? [] : "";
        }
        return (this.addrole = false);
      }
      var i = 1;
      let jiaoyanobj = [
        "chineseName",
        "mobile",
        "password",
        "username",
        "roleIdList",
      ];
      i = jiaoyanobj.every((item) => {
        return this.infoobj[item] == 0 || Boolean(this.infoobj[item]);
      });
      if (!i) return this.$message.error("必填项不能为空");
      if (this.infoobj.password != this.password1)
        return this.$message.error("两次密码不一致");
      this.infoobj.roleIdList = this.checkitem.filter((item) => {
        return item.check != 0;
      });
      if (!this.infoobj.roleIdList.length)
        return this.$message.error("至少选择一个权限");
      if (!/^1[23456789][0-9]{8,10}$/.test(this.infoobj.mobile))
        return this.$message.error("手机号格式错误");
      this.infoobj.roleIdList = this.infoobj.roleIdList.map((item) => {
        return item.roleId;
      });
      this.addsavemsg();
    },
    async addsavemsg() {
      this.infoobj.password = encrypt(this.infoobj.password);
      const { data } = await this.$http(
        "api1",
        this.path,
        "post",
        this.infoobj
      );
      if (!data || data.msg != "success") {
        this.$message.error(data.msg);
        return false;
      }
      this.$message.success("操作成功");
      this.huifuinfoobj();
      delete this.infoobj.userId;
      this.reload();
    },
    huifuinfoobj() {
      this.infoobj = {
        sys: "",
        chineseName: "", //用户名
        username: "", //登录名称
        mobile: "", //联系方式
        password: "", //密码
        roleIdList: [],
        systemName: "system", //用户名
      };
    },
  },
};
</script>

<style lang="scss" src="@/assets/components.scss" scoped></style>